export const SUGGESTED_QUESTIONS = [
  'What is a Submission?',
  'What is Ceding company',
  'What is Reinsurance?',
  'Types of Submissions in Chatbot?',
  'How to bind a Submission?',
  'What is meant by retention amount?',
  'What is a pending broker?',
  'Can you tell me something about pro rata?',
  'Steps to create a Treaty by renewing an existing treaty?',
  'Difference between Pro Rata and XOL Treaty.',
  'What is an assumed and ceded treaty?',
  'Terrorism Exposure configuration in Chatbot.',
  'How to activate a treaty?'
] as const;
